const PrevArrow = (props) => {
  const { onClick } = props;
  return <i className={`fa fa-angle-right slick-arrow`} onClick={onClick} />;
};

export default PrevArrow;
